import axiosInstance from "shared/services";
import { ICameras, IAllCameras } from "modules/cameras/types";

const uri = "cameras";

export const all = async (companyId?: number | null): Promise<IAllCameras> => {
  return axiosInstance
    .get(`${uri}/all${companyId ? `?companyId=${companyId}` : ""}`)
    .then();
};

export const cameraFilter = async (
  companyId?: number,
  page?: number
): Promise<ICameras> => {
  return axiosInstance
    .get(`/cameras?company_id=${!companyId ? "" : companyId}&page=${page}`)
    .then();
};
